import React, { createContext, useContext, useEffect, useState } from 'react';
import safeAreaInsets from 'safe-area-insets';

import getThemeConfig from 'Util/ThemeConfig';

const theme = getThemeConfig();
const OffsetContext = createContext();

const OffsetProvider = ({ children }) => {
  const [offset, setOffset] = useState({
    topOffset: safeAreaInsets.top,
    bottomOffset: safeAreaInsets.bottom,
  });

  useEffect(() => {
    // initial offset
    theme.space.APP_TOP_OFFSET = safeAreaInsets.top;
    safeAreaInsets.onChange((offset) => {
      theme.space.APP_TOP_OFFSET = safeAreaInsets.top;
      setOffset({ topOffset: safeAreaInsets.top, bottomOffset: safeAreaInsets.bottom });
    });
    return () => {
      safeAreaInsets.offChange();
    };
  }, []);

  return <OffsetContext.Provider value={offset}>{children}</OffsetContext.Provider>;
};

const useOffset = () => {
  const context = useContext(OffsetContext);

  if (context === undefined) {
    throw new Error('useOffset must be used within a OffsetProvider');
  }

  return context;
};

export { OffsetContext, useOffset };
export default OffsetProvider;
